module.exports = "/_next/static/images/loading_15-379e119222211d451f504f6791ce4c8d.png";